import { useField } from 'formik'
import { Images } from 'blaze-ui/icons'
import { Field } from './Field'
import { Input } from 'almanac-ui/TextInputField/Input'

export const DescriptionField = () => {
  const [field, meta, helpers] = useField<string>('description')

  return (
    <Field icon={Images} label="Content Description">
      <Input
        value={field.value}
        onChange={(e) => helpers.setValue(e.target.value)}
        placeholder="Enter a description for the campaign"
        isValid={!meta.touched || !meta.error}
        errorMessage={meta.touched && meta.error}
        name="description"
        isTextarea
      />
    </Field>
  )
}
